/* GL Custom — Pagina Configuratore (layout ad arco) sopra il configuratore vero dell'app.
   - carica la scheda prodotto del modello scelto in [data-glc-host] (fuori schermo) e ci avvia lo
     script dell'app GLC Configuratore, che monta il 3D nel primo [data-glc-3d-slot] (al centro)
   - a sinistra gli step sull'arco; a destra le opzioni dello step attivo SULL'ARCO, disegnate con le
     classi dell'app (glc-value, glc-swatch...), quindi uguali alla scheda prodotto
   - ogni scelta viene riportata sull'input vero dell'app: 3D, supplementi, variante e carrello
     restano dell'app e del tema
   - cambio modello senza ricaricare la pagina; gli altri modelli vengono pre-scaricati
   - step "Extra": prodotti aggiuntivi (Priority, 5° cerchio) aggiunti al carrello insieme al set */
(function () {
  'use strict';

  var W = 1440, H = 870, R = 460;
  var CX = 720, CY = 365;        // un solo cerchio, centrato sul 3D: step a sinistra, opzioni a destra
  var ARC = 0.86;                // mezza apertura degli archi (radianti)
  var SLOTS = 9;                 // fallback per la paginazione
  // viste rapide del 3D (angoli come quelli dell'app: polare dall'alto, azimut 0 = fronte)
  var VIEWS = [
    { name: 'Vista 3/4', polar: 1.22, az: 0.62, dist: 3.2 },
    { name: 'Vista frontale', polar: 1.48, az: 0, dist: 3.0 },
    { name: 'Vista dal basso', polar: 2.0, az: -0.6, dist: 3.0, free: true }   // solo con rotazione libera
  ];
  function views() { return VIEWS.filter(function (v) { return !v.free || window.__glcFree; }); }
  // inquadratura automatica per fase: solo le viste delle icone (nome della vista)
  var PHASES = [
    [/beadlock|attacco|foratura|pcd/i, /frontale/i],
    [/.*/, /3\/4/]
  ];
  function viewFor(st) {
    var l = (st && (st.key === 'model' ? 'modello' : st.label)) || '', re = /3\/4/;
    for (var i = 0; i < PHASES.length; i++) if (PHASES[i][0].test(l)) { re = PHASES[i][1]; break; }
    var vi = 0;
    views().forEach(function (v, i) { if (re.test(v.name)) vi = i; });
    return vi;
  }

  var FOV = 37;                  // campo visivo del 3D su questa pagina (l'app usa 45): cerchio piu' grande
  var DESKTOP = window.matchMedia('(min-width: 1100px)');
  var APP_SCRIPT = /glc-configurator\.js/;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function txt(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function clean(v) { return String(v).replace(/\s*-\s*Consigliat[oa]\s*$/i, ''); }
  function noPrice(v) { return String(v).replace(/\s*\([^)]*€[^)]*\)\s*$/, ''); }
  function parseEur(s) {
    var m = String(s || '').replace(/[^\d,.\-]/g, '');
    if (!m) return 0;
    m = m.replace(/\./g, '').replace(',', '.');
    var n = parseFloat(m);
    return isNaN(n) ? 0 : Math.round(n * 100);
  }
  function getPage(url) {
    window.__glcPages = window.__glcPages || {};
    if (!window.__glcPages[url]) {
      window.__glcPages[url] = Promise.all([
        fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }),
        fetch(url + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      ]);
    }
    return window.__glcPages[url];
  }

  function Page(el) {
    this.el = el;
    try { this.d = JSON.parse(el.querySelector('[data-glc-data]').textContent); } catch (e) { return; }
    this.t = this.d.texts || {};
    var nf = new Intl.NumberFormat('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2, useGrouping: 'always' });
    this.money = function (cents) { return '€' + nf.format(cents / 100); }; // come il tema: €1.000,00
    this.models = (this.d.models || []).filter(Boolean);
    this.extras = (this.d.extras || []).filter(function (x) { return x.available; });
    this.extraOn = {};
    if (!this.models.length) { this.fail('Seleziona i modelli nelle impostazioni della sezione.'); return; }

    var h = null;
    try { h = new URL(location.href).searchParams.get('modello'); } catch (e) {}
    this.mIdx = 0;
    for (var i = 0; i < this.models.length; i++) if (this.models[i].handle === h) this.mIdx = i;
    this.model = this.models[this.mIdx];

    this.$ = function (s) { return el.querySelector(s); };
    this.host = this.$('[data-glc-host]');
    this.stepKey = 'model';              // si parte SEMPRE dalla scelta del modello
    this.off = {};                       // rotazione dell'arco per step con molte opzioni
    this.msg = ''; this.msgType = '';
    this.busy = false;
    this.loads = 0;

    var self = this;
    el.addEventListener('click', function (e) { self.onClick(e); });
    el.addEventListener('change', function (e) { self.onProxy(e); });
    el.addEventListener('input', function (e) { if (e.target.matches('input[type="text"], input[type="number"], textarea')) self.onProxy(e); });
    var opts = this.$('[data-glc-opts]');
    opts.addEventListener('wheel', function (e) { self.onWheel(e); }, { passive: false });
    window.addEventListener('resize', function () { self.fit(); });
    if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', function () { self.render(); });
    document.addEventListener('variant:add', function (e) { self.added(e); });

    this.render();
    this.load();
  }

  Page.prototype.fail = function (m) {
    var l = this.el.querySelector('[data-glc-wait]');
    if (!l) return;
    l.hidden = false;
    l.innerHTML = '<p>' + esc(m) + '</p><button type="button" class="button" data-act="retry">Riprova</button>';
  };
  Page.prototype.waiting = function (on) {
    var l = this.el.querySelector('[data-glc-wait]');
    if (!l) return;
    if (on) { l.hidden = false; l.innerHTML = '<span></span>Carico il configuratore 3D…'; } else l.hidden = true;
  };

  /* ---------- carica (o cambia) il modello ---------- */
  // Sfondo del 3D trasparente, solo su questa pagina: l'app crea la scena con
  // scene.background = grigio fisso. Prima che parta, intercetto quell'assegnazione
  // (stessa istanza di three, via importmap) e lascio lo sfondo vuoto: il renderer
  // dell'app e' gia' trasparente (alpha: true), quindi il cerchio poggia sulla pagina.
  // Per l'anteprima che va nell'ordine (JPG) rimetto un fondo pieno al momento dello scatto.
  function transparentBackground(fill) {
    if (window.__glcBgPatched) return window.__glcBgPatched;
    window.__glcBgFill = fill;
    window.__glcBgPatched = new Promise(function (done) {
      var finished = false;
      window.__glcBgDone = function (ok) { if (!finished) { finished = true; window.__glcBgOk = !!ok; done(); } };
      var s = document.createElement('script');
      s.type = 'module';
      s.textContent = "import * as T from 'three'; window.__glcTHREE = T; window.__glcBgDone(true);";
      s.onerror = function () { console.warn('[GLC] three non caricato per lo sfondo trasparente'); window.__glcBgDone(false); };
      document.head.appendChild(s);
      setTimeout(function () { window.__glcBgDone(false); }, 5000);
    }).then(function () { if (window.__glcTHREE) patchThree(window.__glcTHREE); });
    return window.__glcBgPatched;
  }

  function patchThree(T) {
    var inSlot = function (el) { return el && el.closest && el.closest('[data-glc-3d-slot]'); };
    try {
      var p = T.Scene.prototype;
      if (!Object.getOwnPropertyDescriptor(p, 'background')) Object.defineProperty(p, 'background', { configurable: true,
        get: function () { return this.__glcBg === undefined ? null : this.__glcBg; },
        set: function (v) { if (v && v.isColor) window.__glcScene = this; this.__glcBg = (v && v.isColor && window.__glcClear) ? null : v; } });
      // OrbitControls dell'app: lo intercetto alla nascita (assegna minPolarAngle nel costruttore).
      // Con la rotazione libera, su questa pagina i limiti di angolo dell'app vengono ignorati.
      var ED = T.EventDispatcher && T.EventDispatcher.prototype;
      if (ED && !Object.getOwnPropertyDescriptor(ED, 'minPolarAngle')) {
        var own = function (o, k, v) { Object.defineProperty(o, k, { value: v, writable: true, configurable: true, enumerable: true }); };
        var lim = function (o, k, free) {
          var val = o[k];
          Object.defineProperty(o, k, { configurable: true, enumerable: true,
            get: function () { return window.__glcFree ? free : val; }, set: function (v) { val = v; } });
        };
        Object.defineProperty(ED, 'minPolarAngle', { configurable: true,
          get: function () { return undefined; },
          set: function (v) {
            own(this, 'minPolarAngle', v);
            if (this.object && this.object.isCamera) {
              lim(this, 'maxPolarAngle', Math.PI - 0.08);
              // la rotazione orizzontale resta quella dell'app (±100° dal fronte): il retro del cerchio non si vede
              window.__glcCtl = this;
            }
          } });
      }
      // camera e punto guardato dal 3D (OrbitControls chiama camera.lookAt(target) a ogni frame;
      // le camere delle ombre sono ortografiche e restano fuori; dopo un cambio modello vince la camera piu' nuova)
      var la = T.Object3D.prototype.lookAt;
      if (!la.__glc) {
        var g = function (x) {
          if (!window.__glcSnapping && this.isPerspectiveCamera && x && x.isVector3) {
            this.__glcTarget = x;
            if (!window.__glcCam || this.id >= window.__glcCam.id) window.__glcCam = this;
            if (window.__glcFov && !this.__glcFov) { this.__glcFov = true; this.fov = window.__glcFov; this.updateProjectionMatrix(); }
          }
          return la.apply(this, arguments);
        };
        g.__glc = true; T.Object3D.prototype.lookAt = g;
      }
      // renderer dell'app (il costruttore assegna toneMappingExposure): serve per le anteprime istantanee
      var RP = T.WebGLRenderer && T.WebGLRenderer.prototype;
      if (RP && !Object.getOwnPropertyDescriptor(RP, 'toneMappingExposure')) {
        Object.defineProperty(RP, 'toneMappingExposure', { configurable: true,
          get: function () { return undefined; },
          set: function (v) {
            Object.defineProperty(this, 'toneMappingExposure', { value: v, writable: true, configurable: true, enumerable: true });
            (window.__glcRenderers = window.__glcRenderers || []).push(this);
          } });
      }
      var o = HTMLCanvasElement.prototype.toDataURL;
      if (!o.__glc) {
        var f = function (type) {
          if (window.__glcClear && /jpe?g/i.test(type || '') && inSlot(this)) {
            var c = document.createElement('canvas'); c.width = this.width; c.height = this.height;
            var x = c.getContext('2d'); x.fillStyle = window.__glcBgFill || '#ffffff'; x.fillRect(0, 0, c.width, c.height);
            x.drawImage(this, 0, 0); return o.apply(c, arguments);
          }
          return o.apply(this, arguments);
        };
        f.__glc = true; HTMLCanvasElement.prototype.toDataURL = f;
      }
    } catch (e) { console.warn('[GLC] patch 3D', e); }
  }

  /* ---------- viste rapide del 3D ---------- */
  function ease(t) { return t < .5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }
  Page.prototype.canvas3d = function () {
    var cs = this.el.querySelectorAll('[data-glc-3d-slot] canvas:not(.glc-freeze)');
    for (var i = 0; i < cs.length; i++) if (!cs[i].closest('[id$="-old"]')) return cs[i];
    return null;
  };
  Page.prototype.camOK = function () {
    var T = window.__glcTHREE, ctl = window.__glcCtl, cam = window.__glcCam;
    if (!T || !this.canvas3d()) return null;
    if (ctl && ctl.object && ctl.target && ctl.domElement === this.canvas3d()) { ctl.object.__glcTarget = ctl.target; return ctl.object; }
    return cam && cam.__glcTarget ? cam : null;
  };
  Page.prototype.loading3d = function () {
    var o = this.$('[data-glc-3d-slot] .tc-loader-overlay');
    return !!(o && parseFloat(getComputedStyle(o).opacity) > 0.05);
  };
  Page.prototype.goView = function (i) { var v = views()[i]; if (v) this.goPose(v, i); };
  // porta la camera su una posa; se il 3D non e' ancora pronto ritenta per qualche secondo
  Page.prototype.goPose = function (v, i, tries) {
    var cam = this.camOK(), T = window.__glcTHREE, self = this;
    if (!cam || this.snapping || this.dragging) {
      if ((tries || 0) < 25) { clearTimeout(this._poseT); this._poseT = setTimeout(function () { self.goPose(v, i, (tries || 0) + 1); }, 300); }
      return;
    }
    var tgt = cam.__glcTarget;
    var from = new T.Spherical().setFromVector3(cam.position.clone().sub(tgt));
    var to = new T.Spherical(v.dist, v.polar, v.az);
    var d = to.theta - from.theta;
    if (Math.abs(d) < 0.02 && Math.abs(to.phi - from.phi) < 0.02 && Math.abs(to.radius - from.radius) < 0.05) { this.view = i; this.renderViews(); return; }
    this.view = i; this.renderViews();
    var t0 = performance.now(), dur = 650, id = this._anim = {};
    this.animating = true;
    (function step(now) {
      if (self._anim !== id) { return; }
      var k = ease(Math.min(1, (now - t0) / dur));
      if (k >= 1) self.animating = false;
      var sp = new T.Spherical(from.radius + (to.radius - from.radius) * k, from.phi + (to.phi - from.phi) * k, from.theta + d * k);
      cam.position.copy(tgt).add(new T.Vector3().setFromSpherical(sp));
      cam.lookAt(tgt);
      if (k < 1) requestAnimationFrame(step);
    })(t0);
  };
  // anteprime delle 3 viste: congelo l'immagine attuale, faccio girare la camera dietro, catturo, rimetto
  Page.prototype.snapViews = function () {
    var self = this, cam = this.camOK(), T = window.__glcTHREE, cv = this.canvas3d();
    if (!cam || this.snapping || this.loading3d() || this.dragging || this.animating) return false;
    if (!cv.width || !cv.height) return false;
    this.snapping = true;
    var tgt = cam.__glcTarget, save = cam.position.clone();
    if (getComputedStyle(cv.parentNode).position === 'static') cv.parentNode.style.position = 'relative';
    var freeze = document.createElement('canvas');
    freeze.width = cv.width; freeze.height = cv.height;
    freeze.className = 'glc-freeze';
    try { freeze.getContext('2d').drawImage(cv, 0, 0); } catch (e) {}
    cv.parentNode.appendChild(freeze);
    var shots = [], i = 0, S = 160, VS = views();
    function frames(n, fn) { if (n <= 0) fn(); else requestAnimationFrame(function () { frames(n - 1, fn); }); }
    function next() {
      if (i >= VS.length) {
        cam.position.copy(save); cam.lookAt(tgt);
        frames(2, function () { freeze.remove(); self.snapping = false; self.shots = shots; self.renderViews(); });
        return;
      }
      var v = VS[i];
      cam.position.copy(tgt).add(new T.Vector3().setFromSphericalCoords(v.dist, v.polar, v.az));
      cam.lookAt(tgt);
      frames(2, function () {
        var side = Math.min(cv.width, cv.height), c = document.createElement('canvas');
        c.width = S; c.height = S;
        try {
          c.getContext('2d').drawImage(cv, (cv.width - side) / 2, (cv.height - side) / 2, side, side, 0, 0, S, S);
          shots[i] = c.toDataURL('image/png');
        } catch (e) { shots[i] = null; }
        i++; next();
      });
    }
    next();
    return true;
  };
  // anteprime istantanee: renderizzo le viste con il renderer dell'app e una copia della camera,
  // poi ridisegno la vista attuale, tutto nello stesso istante (niente scatti, la camera vera non si muove)
  Page.prototype.snapFast = function () {
    var cam = this.camOK(), cv = this.canvas3d(), sc = window.__glcScene, r = null;
    (window.__glcRenderers || []).forEach(function (x) { if (x.domElement === cv) r = x; });
    if (!cam || !cv || !sc || !r || !cv.width || !cv.height) return false;
    var T = window.__glcTHREE, tgt = cam.__glcTarget, VS = views(), shots = [], S = 160;
    var side = Math.min(cv.width, cv.height);
    var c2 = cam.clone();
    window.__glcSnapping = true;
    try {
      VS.forEach(function (v, i) {
        c2.position.copy(tgt).add(new T.Vector3().setFromSphericalCoords(v.dist, v.polar, v.az));
        c2.lookAt(tgt); c2.updateMatrixWorld();
        r.render(sc, c2);
        var c = document.createElement('canvas'); c.width = S; c.height = S;
        c.getContext('2d').drawImage(cv, (cv.width - side) / 2, (cv.height - side) / 2, side, side, 0, 0, S, S);
        shots[i] = c;
      });
    } catch (e) { shots = null; }
    try { r.render(sc, cam); } catch (e) {}
    window.__glcSnapping = false;
    if (!shots) return false;
    this.shots = shots; this.renderViews();
    return true;
  };
  Page.prototype.snapNow = function () {
    if (this.loading3d() || this.dragging || this.snapping) return false;
    return this.snapFast() || this.snapViews();
  };
  Page.prototype.queueSnap = function (delay) {
    this._snapAt = Date.now() + (delay == null ? 60 : delay);
  };
  Page.prototype.tick = function () {
    // prezzo: la variante (es. Beadlock si/no) cambia senza eventi sul nostro lato
    var v = this.variant(), id = v ? v.id : null;
    if (id !== this._vid) { this._vid = id; this.render(); }
    // anteprime: appena il 3D ha finito di caricare, e subito dopo ogni scelta
    var loading = this.loading3d();
    if (this._wasLoading && !loading) this.queueSnap(30);
    this._wasLoading = loading;
    if (this._snapAt && Date.now() >= this._snapAt && !loading) {
      if (this.snapNow()) { this._snapAt = this._snapAgain || 0; this._snapAgain = 0; }
    }
  };
  Page.prototype.renderViews = function () {
    var box = this.$('[data-glc-views]');
    if (!box) return;
    var self = this;
    box.hidden = !this.root;
    box.innerHTML = views().map(function (v, i) {
      var img = self.shots && self.shots[i];
      return '<button type="button" class="glc-view' + (self.view === i ? ' is-active' : '') + '" data-act="view" data-view="' + i + '" aria-label="' + esc(v.name) + '" title="' + esc(v.name) + '">' +
        (typeof img === 'string' ? '<img src="' + img + '" alt="">' : (img ? '' : '<span class="glc-view__ph" aria-hidden="true"></span>')) + '</button>';
    }).join('');
    // anteprime disegnate direttamente (canvas): nessuna conversione, compaiono subito
    Array.prototype.forEach.call(box.querySelectorAll('.glc-view'), function (b, i) {
      var img = self.shots && self.shots[i];
      if (img && typeof img !== 'string') b.appendChild(img);
    });
  };

  Page.prototype.load = function () {
    var self = this, model = this.model, n = ++this.loads;
    this.waiting(true);
    window.__glcClear = !!this.d.transparent3d;
    window.__glcFree = this.d.freeOrbit !== false;
    window.__glcFov = FOV;
    var bg = transparentBackground(this.d.previewFill || '#ffffff');
    Promise.all([getPage(model.url), bg]).then(function (all) {
      var res = all[0];
      if (n !== self.loads) return;               // nel frattempo si e' scelto un altro modello
      self.product = res[1];
      var doc = new DOMParser().parseFromString(res[0], 'text/html');
      var root = doc.querySelector('[data-glc-root]');
      if (!root) { self.fail('Questo modello non ha ancora il configuratore 3D nella scheda prodotto.'); return; }
      var section = root.closest('.shopify-section') || root.closest('product-rerender') || root.parentElement;
      // via galleria, posto 3D e importmap: il 3D va al centro di questa pagina
      section.querySelectorAll('product-gallery, .product-gallery, [data-glc-3d-slot], [data-glc-3d-thumb], product-recommendations').forEach(function (x) { x.remove(); });
      section.querySelectorAll('script[type="importmap"]').forEach(function (x) { x.remove(); });
      self.teardown();
      self.host.innerHTML = section.outerHTML;
      self.runScripts(self.host, n > 1);
      self.waitBoot(n);
    }).catch(function (err) {
      console.error('GL configuratore', err);
      self.fail('Non riesco a caricare il configuratore.');
    });
  };

  // smonta il modello precedente: osservatori, 3D (libera la scheda video) e aggancio al carrello
  Page.prototype.teardown = function () {
    if (this.mo) { this.mo.disconnect(); this.mo = null; }
    this.root = null; this.form = null;
    this.oldBoxes = Array.prototype.filter.call(this.$('[data-glc-3d-slot]').children, function (c) { return !c.hasAttribute('data-glc-wait'); });
    // il blocco app ha lo stesso id su tutti i modelli: rinomino il 3D vecchio, altrimenti
    // il nuovo avvio (getElementById) si aggancerebbe a lui
    this.oldBoxes.forEach(function (b) {
      [b].concat(Array.prototype.slice.call(b.querySelectorAll('[id]'))).forEach(function (x) { if (x.id) x.id += '-old'; });
      b.removeAttribute('data-glc-3d');
    });
    // l'app aggancia una sola volta il fetch del carrello (anteprima 3D nell'ordine): lo sgancio,
    // cosi' il nuovo avvio lo riaggancia al 3D del modello nuovo
    if (window.__tcCartFetchPatched && window.__tcOrigFetch) {
      window.fetch = window.__tcOrigFetch;
      window.__tcCartFetchPatched = false;
    }
  };

  Page.prototype.dropOldBoxes = function () {
    (this.oldBoxes || []).forEach(function (b) {
      var c = b.querySelector('canvas');
      if (c) {
        try {
          var gl = c.getContext('webgl2') || c.getContext('webgl');
          var ext = gl && gl.getExtension('WEBGL_lose_context');
          if (ext) ext.loseContext();
        } catch (e) {}
      }
      b.remove();
    });
    this.oldBoxes = [];
  };

  Page.prototype.runScripts = function (scope, rerun) {
    var self = this, loaded = {};
    document.querySelectorAll('script[src]').forEach(function (s) { if (!scope.contains(s)) loaded[s.src.split('?')[0]] = true; });
    scope.querySelectorAll('script').forEach(function (old) {
      var type = (old.getAttribute('type') || '').toLowerCase();
      if (type === 'application/json' || type === 'application/ld+json') return; // dati: restano leggibili cosi'
      var src = old.src ? old.src.split('?')[0] : '';
      var isApp = src && APP_SCRIPT.test(src);
      if (src && loaded[src] && !isApp) { old.remove(); return; }
      var s = document.createElement('script');
      for (var i = 0; i < old.attributes.length; i++) s.setAttribute(old.attributes[i].name, old.attributes[i].value);
      // lo script dell'app e' un modulo: per riavviarlo su un modello nuovo serve un indirizzo diverso
      if (isApp && rerun) s.src = old.src + (old.src.indexOf('?') < 0 ? '?' : '&') + 'glcr=' + Date.now();
      if (isApp) s.addEventListener('error', function () { self.fail('Il configuratore 3D non si è caricato.'); });
      if (!old.src) s.textContent = old.textContent;
      else if (type !== 'module') s.async = false;
      old.replaceWith(s);
      if (src) loaded[src] = true;
    });
  };

  Page.prototype.waitBoot = function (n) {
    var self = this, tries = 0;
    (function check() {
      if (n !== self.loads) return;
      var root = self.host.querySelector('[data-glc-root]');
      if (root && root.__glcBooted) { self.ready(root); return; }
      if (++tries > 600) { self.fail('Il configuratore 3D ci sta mettendo troppo.'); return; }
      setTimeout(check, 50);
    })();
  };

  Page.prototype.ready = function (root) {
    var self = this;
    this.root = root;
    this.form = document.getElementById(root.dataset.glcForm) || this.host.querySelector('form[action*="/cart/add"]');
    this.el.classList.add('is-ready');
    this.el.classList.remove('is-switching');
    this.mo = new MutationObserver(function () { self.schedule(); });
    this.mo.observe(root, { subtree: true, attributes: true, attributeFilter: ['hidden', 'style', 'class', 'disabled'], childList: true, characterData: true });
    root.addEventListener('change', function () { self.schedule(); });
    if (this.form) this.form.addEventListener('change', function () { self.schedule(); });
    // il 3D nuovo e' montato: via quello vecchio e la rotella
    (function waitCanvas(k) {
      var boxes = Array.prototype.filter.call(self.$('[data-glc-3d-slot]').children, function (c) { return !c.hasAttribute('data-glc-wait') && (self.oldBoxes || []).indexOf(c) < 0; });
      if ((boxes.length && boxes[0].querySelector('canvas')) || k > 100) { self.dropOldBoxes(); self.waiting(false); return; }
      setTimeout(function () { waitCanvas(k + 1); }, 60);
    })(0);
    this.render();
    this.renderViews();
    this._sig = null;
    var slot = this.$('[data-glc-3d-slot]');
    if (!slot.__glcDrag) {
      slot.__glcDrag = true;
      slot.addEventListener('pointerdown', function () { self.dragging = true; self._anim = null; self.animating = false; if (self.view != null) { self.view = null; self.renderViews(); } });
      window.addEventListener('pointerup', function () { if (self.dragging) { self.dragging = false; } });
      slot.addEventListener('wheel', function () { if (self.view != null) { self.view = null; self.renderViews(); } }, { passive: true });
    }
    this._wasLoading = true;
    this.queueSnap(400);
    clearInterval(this._tick);
    this._tick = setInterval(function () { self.tick(); }, 120);
    if (this.carry) this.applyCarry(this.carry);
    this.carry = null;
    // pre-scarica gli altri modelli, cosi' il cambio e' immediato
    var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 1500); };
    idle(function () { self.models.forEach(function (m) { getPage(m.url); }); });
  };

  Page.prototype.switchModel = function (i) {
    if (i === this.mIdx) return;
    this.carry = this.collectCarry();
    this.mIdx = i; this.model = this.models[i];
    this.off = {};
    this.shots = null; this.view = null; this._anim = null; this.animating = false;
    this.renderViews();
    try { var u = new URL(location.href); u.searchParams.set('modello', this.model.handle); history.replaceState(history.state, '', u.toString()); } catch (e) {}
    this.el.classList.add('is-switching');
    this.stepKey = 'model';
    this.render();
    this.load();
  };

  // scelte da portare sul nuovo modello (colori, beadlock, misure...): stesso nome di opzione e stesso valore
  function norm(x) { return String(x || '').toLowerCase().replace(/\s+/g, ' ').trim(); }
  Page.prototype.collectCarry = function () {
    var out = {};
    this.steps().forEach(function (st) {
      if (!st.info) return;
      var inf = st.info, val = null;
      if (inf.kind === 'text') val = inf.input.value;
      else inf.items.forEach(function (it) { if (it.selected) val = it.text; });
      if (val) out[norm(st.title)] = val;
    });
    return out;
  };
  Page.prototype.applyCarry = function (carry) {
    var self = this, keys = Object.keys(carry), k = 0;
    (function next() {
      if (k >= keys.length || !self.root) { self.schedule(); return; }
      var key = keys[k++], val = norm(carry[key]);
      var st = self.steps().filter(function (s) { return s.info && norm(s.title) === key; })[0];
      if (!st) return next();
      var inf = st.info;
      if (inf.kind === 'text') {
        inf.input.value = carry[key];
        inf.input.dispatchEvent(new Event('input', { bubbles: true }));
        inf.input.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        var it = inf.items.filter(function (x) { return norm(x.text) === val; })[0];
        if (!it || it.selected || it.disabled) return next();
        if (inf.kind === 'select') { inf.select.value = it.val; inf.select.dispatchEvent(new Event('change', { bubbles: true })); }
        else if (it.label) it.label.click();
        else { it.input.checked = true; it.input.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      setTimeout(next, 90);
    })();
  };

  Page.prototype.schedule = function () {
    var self = this;
    if (this._raf) return;
    this._raf = requestAnimationFrame(function () { self._raf = null; self.render(); });
  };

  /* ---------- lettura dei campi dell'app ---------- */
  function visible(fs) {
    if (fs.hidden || fs.closest('[hidden]')) return false;
    var cs = getComputedStyle(fs);
    return cs.display !== 'none' && cs.visibility !== 'hidden';
  }

  Page.prototype.fieldsets = function () {
    if (!this.root) return [];
    return Array.prototype.filter.call(this.root.querySelectorAll('fieldset.glc-option'), visible);
  };

  function shortLabel(l) {
    return l.replace(/^Scegli (il |lo |la |l'|i |gli |le )?/i, '').replace(/^\w/, function (c) { return c.toUpperCase(); });
  }

  Page.prototype.steps = function () {
    var self = this;
    var out = [{ key: 'model', label: 'Modello', title: 'Scegli il modello', value: this.model.title, required: false, done: true }];
    this.appLinked = null;
    this.fieldsets().forEach(function (fs) {
      var name = fs.getAttribute('data-glc-option') || fs.getAttribute('data-glc-variante-nome') || txt(fs.querySelector('legend')).replace(/\*/g, '').trim();
      if (fs.getAttribute('data-glc-option') && LINKED.test(name)) {
        self.appLinked = fs;
        setTimeout(function () { setNo(fs); }, 0);
        return;
      }
      var info = readField(fs);
      out.push({
        key: fs.getAttribute('data-glc-option') ? 'o:' + name : 'v:' + (fs.getAttribute('data-glc-variante') || name),
        fs: fs, info: info, label: shortLabel(name), title: name,
        required: !!fs.querySelector('.glc-required') || !!fs.querySelector('[required]'),
        value: info.value || '—', done: !!info.value
      });
    });
    // ordine naturale dei passi: misure e montaggio, colore del cerchio, poi tutto il beadlock insieme
    // (si/no -> stile -> colore), poi il resto (es. Priority). Voci non riconosciute: dopo, nel loro ordine.
    var ORDER = [/diametro|dimensione/i, /larghezza/i, /attacco/i, /^et$|offset/i, /colore del cerchio|colore cerchio/i,
                 /^beadlock$/i, /stile.*beadlock/i, /colore.*beadlock/i];
    var rank = function (st, i) {
      for (var k = 0; k < ORDER.length; k++) if (ORDER[k].test(st.label)) return k;
      return ORDER.length + i;
    };
    var head = out.shift();
    out = out.map(function (st, i) { return { st: st, r: rank(st, i) }; })
      .sort(function (a, b) { return a.r - b.r; }).map(function (x) { return x.st; });
    out.unshift(head);
    var shown = this.shownExtras();
    if (this.root && shown.length) {
      var on = shown.filter(function (x) { return self.extraOn[x.id]; }).map(function (x) { return x.title; });
      out.push({ key: 'extra', label: this.t.extraLabel || 'Extra', title: this.t.extraTitle || 'Vuoi aggiungere qualcosa?', value: on.length ? on.join(', ') : 'Nessuno', required: false, done: true });
    }
    return out;
  };

  // opzioni di un campo dell'app, nel formato usato per disegnarle
  function readField(fs) {
    var type = fs.getAttribute('data-glc-type') || (fs.classList.contains('glc-option--variante') ? 'variante' : '');
    var res = { type: type, items: [], value: '' };
    var sel = fs.querySelector('select');
    if (sel) {
      res.kind = 'select'; res.select = sel;
      Array.prototype.forEach.call(sel.options, function (o) {
        if (!o.value) return;
        res.items.push({ val: o.value, text: o.textContent.trim(), selected: sel.value === o.value, disabled: o.disabled });
      });
      res.value = sel.value ? clean(sel.value) : '';
      return res;
    }
    var t = fs.querySelector('input[type="text"], input[type="number"], textarea');
    if (t) { res.kind = 'text'; res.input = t; res.value = t.value.trim(); return res; }
    res.kind = 'choice';
    var inputs = fs.querySelectorAll('input[type="radio"], input[type="checkbox"]');
    Array.prototype.forEach.call(inputs, function (inp, i) {
      var lab = fs.querySelector('label[for="' + CSS.escape(inp.id) + '"]');
      var name = noPrice((lab && (lab.getAttribute('title') || txt(lab.querySelector('.glc-value__text')))) || inp.value);
      res.items.push({ idx: i, val: inp.value, text: clean(name), full: name, input: inp, label: lab, selected: inp.checked, disabled: inp.disabled, hex: inp.getAttribute('data-glc-color') || '' });
      if (inp.checked) res.value = clean(name);
    });
    return res;
  }

  Page.prototype.currentStep = function (steps) {
    for (var i = 0; i < steps.length; i++) if (steps[i].key === this.stepKey) return i;
    return 0;
  };

  /* ---------- prezzo / carrello ---------- */
  Page.prototype.variant = function () {
    if (!this.product || !this.form) return null;
    var idEl = this.form.querySelector('[name="id"]');
    var id = idEl && String(idEl.value);
    var vs = this.product.variants || [];
    for (var i = 0; i < vs.length; i++) if (String(vs[i].id) === id) return vs[i];
    return null;
  };

  Page.prototype.supplement = function () {
    if (!this.root) return 0;
    var box = this.root.querySelector('[data-glc-total]');
    if (!box || box.hidden) return 0;
    return parseEur(txt(this.root.querySelector('[data-glc-total-amount]')));
  };

  // extra proposti: un extra legato a un'opzione dell'app (es. Priority) compare solo se
  // quell'opzione e' attiva nell'app GLC Configurator per il modello scelto
  var LINKED = /priority/i;
  Page.prototype.shownExtras = function () {
    var self = this;
    return this.extras.filter(function (x) {
      var ok = !LINKED.test(x.title) || !!self.appLinked;
      if (!ok) delete self.extraOn[x.id];
      return ok;
    });
  };
  // l'opzione dell'app gemella dell'extra non si mostra come passo: la tengo su "No"
  // (cosi' il campo obbligatorio e' valido e non si paga due volte)
  function setNo(fs) {
    var sel = fs.querySelector('select');
    if (sel) {
      var no = Array.prototype.filter.call(sel.options, function (o) { return /^no\b/i.test(o.value); })[0];
      if (no && sel.value !== no.value) { sel.value = no.value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
      return;
    }
    var inp = Array.prototype.filter.call(fs.querySelectorAll('input[type="radio"]'), function (i) { return /^no\b/i.test(i.value); })[0];
    if (inp && !inp.checked) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
  }

  Page.prototype.extrasTotal = function () {
    var self = this;
    return this.shownExtras().reduce(function (s, x) { return s + (self.extraOn[x.id] ? x.price : 0); }, 0);
  };

  Page.prototype.submitButton = function () {
    if (!this.form) return null;
    return this.form.querySelector('[type="submit"]') ||
      (this.form.id && document.querySelector('[form="' + CSS.escape(this.form.id) + '"][type="submit"]'));
  };

  Page.prototype.addToCart = function () {
    var steps = this.steps();
    for (var i = 1; i < steps.length; i++) {
      if (steps[i].required && !steps[i].done) {
        this.stepKey = steps[i].key;
        this.msg = 'Manca una scelta: ' + steps[i].title; this.msgType = 'err';
        this.render(); return;
      }
    }
    var btn = this.submitButton();
    if (!btn || btn.disabled) return;
    var self = this;
    this.busy = true; this.msg = ''; this.render();
    clearTimeout(this._t);
    this._t = setTimeout(function () {
      if (!self.busy) return;
      self.busy = false; self.msg = 'Non sono riuscito ad aggiungere al carrello. Riprova.'; self.msgType = 'err'; self.render();
    }, 15000);
    if (this.form.requestSubmit) this.form.requestSubmit(btn); else btn.click();
  };

  // il set e' nel carrello: aggiungo gli extra scelti, poi aggiorno il carrello del tema
  Page.prototype.added = function () {
    if (!this.busy) return;
    clearTimeout(this._t);
    var self = this;
    var items = this.shownExtras().filter(function (x) { return self.extraOn[x.id]; }).map(function (x) {
      return { id: x.id, quantity: 1, properties: { Per: self.model.title } };
    });
    var done = function (ok) {
      self.busy = false;
      self.msg = ok ? 'Aggiunto al carrello' : 'Set aggiunto, ma gli extra no: aggiungili dal carrello.';
      self.msgType = ok ? 'ok' : 'err';
      self.render();
    };
    if (!items.length) { done(true); return; }
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      done(r.ok);
    }).catch(function () { done(false); });
  };

  /* ---------- eventi ---------- */
  Page.prototype.onClick = function (e) {
    var b = e.target.closest('[data-act]');
    if (!b || b.disabled || b.closest('[data-glc-host]')) return;
    var act = b.getAttribute('data-act');
    var steps = this.steps(), cur = this.currentStep(steps);
    if (act === 'step') { this.stepKey = b.getAttribute('data-key'); this.msg = ''; this.mlist = false; this.mdrop = null; this.render(); this.alignMobile(); }
    else if (act === 'next') {
      if (cur + 1 < steps.length) { this.stepKey = steps[cur + 1].key; this.msg = ''; this.mlist = false; this.mdrop = null; this.render(); this.alignMobile(); }
    }
    else if (act === 'prev') {
      if (cur > 0) { this.stepKey = steps[cur - 1].key; this.msg = ''; this.mlist = false; this.mdrop = null; this.render(); this.alignMobile(); }
    }
    else if (act === 'list') { this.mlist = !this.mlist; this.render(); }
    else if (act === 'drop') { var k = b.getAttribute('data-key'); this.mdrop = this.mdrop === k ? null : k; this.render(); }
    else if (act === 'rot') this.rotate(+b.getAttribute('data-dir'));
    else if (act === 'view') this.goView(+b.getAttribute('data-view'));
    else if (act === 'retry') location.reload();
    else if (act === 'add') this.addToCart();
  };

  Page.prototype.onWheel = function (e) {
    if (!DESKTOP.matches || !this.el.querySelector('[data-act="rot"]')) return;
    e.preventDefault();
    var now = Date.now();
    if (now - (this._wheel || 0) < 120) return;
    this._wheel = now;
    this.rotate(e.deltaY > 0 ? 1 : -1);
  };

  Page.prototype.rotate = function (dir) {
    var steps = this.steps(), st = steps[this.currentStep(steps)];
    var n = this.itemsFor(st).length;
    var max = Math.max(0, n - (this.slots || SLOTS));
    var cur = this.off[st.key] != null ? this.off[st.key] : this.defaultOff(st);
    this.off[st.key] = Math.max(0, Math.min(max, cur + dir));
    this.render();
  };

  // scelte fatte sull'arco -> input vero dell'app
  Page.prototype.onProxy = function (e) {
    var t = e.target;
    // menu a tendina da telefono: scelta fatta -> si richiude (le caselle multiple restano aperte)
    if (t.closest && t.closest('.glc-mdd') && t.type !== 'checkbox') this.mdrop = null;
    if (t.hasAttribute('data-glcp-model')) { this.switchModel(+t.getAttribute('data-glcp-model')); return; }
    if (t.hasAttribute('data-glcp-extra')) { this.extraOn[t.getAttribute('data-glcp-extra')] = t.checked; this.render(); return; }
    if (!t.hasAttribute('data-glcp')) return;
    var steps = this.steps(), st = steps[this.currentStep(steps)];
    if (!st || !st.info) return;
    var info = st.info, v = t.getAttribute('data-glcp');
    if (info.kind === 'select') {
      info.select.value = v;
      info.select.dispatchEvent(new Event('change', { bubbles: true }));
    } else if (info.kind === 'text') {
      info.input.value = t.value;
      info.input.dispatchEvent(new Event('input', { bubbles: true }));
      info.input.dispatchEvent(new Event('change', { bubbles: true }));
      if (e.type === 'input') return; // niente re-render mentre si scrive
    } else {
      var it = info.items[+v];
      if (!it) return;
      if (it.label) { if (!it.input.checked || it.input.type === 'checkbox') it.label.click(); }
      else { it.input.checked = t.checked; it.input.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    this.msg = '';
    this.schedule();
  };

  /* ---------- opzioni dello step, con le classi dell'app ---------- */
  Page.prototype.itemsFor = function (st) {
    var self = this;
    if (st.key === 'model') {
      return this.models.map(function (m, i) {
        return { kind: 'image', model: true, attr: 'data-glcp-model="' + i + '"', type: 'radio', selected: i === self.mIdx,
          inner: (m.image ? '<img class="glc-value__img" src="' + esc(m.image) + '" alt="" loading="lazy" width="72" height="72">' : '<span class="glc-value__img glc-value__img--empty" aria-hidden="true"></span>') +
                 '<span class="glc-value__text">' + esc(m.title) + '</span><span class="glc-value__price">' + esc(m.novita ? 'Novità' : 'da ' + self.money(m.priceMin)) + '</span>',
          cls: 'glc-value glc-value--immagine', title: m.title };
      });
    }
    if (st.key === 'extra') {
      return this.shownExtras().map(function (x) {
        return { kind: 'pill', attr: 'data-glcp-extra="' + x.id + '"', type: 'checkbox', selected: !!self.extraOn[x.id],
          inner: '<span class="glc-value__text">' + esc(x.title) + '</span> <span class="glc-value__price">+' + esc(self.money(x.price)) + '</span>',
          cls: 'glc-value glc-value--bottoni', title: x.title };
      });
    }
    if (!st.info) return [];
    var info = st.info;
    if (info.kind === 'select') {
      return info.items.map(function (o) {
        return { kind: 'pill', attr: 'data-glcp="' + esc(o.val) + '"', type: 'radio', selected: o.selected, disabled: o.disabled,
          inner: '<span class="glc-value__text">' + esc(o.text) + '</span>', cls: 'glc-value glc-value--bottoni', title: o.text };
      });
    }
    if (info.kind === 'text') return [];
    return info.items.map(function (o) {
      var cls = o.label ? o.label.className : 'glc-value';
      var kind = info.type === 'colore' ? 'swatch' : (info.type === 'immagine' ? 'image' : 'pill');
      return { kind: kind, attr: 'data-glcp="' + o.idx + '"', type: o.input.type === 'checkbox' ? 'checkbox' : 'radio', selected: o.selected, disabled: o.disabled,
        inner: o.label ? o.label.innerHTML : esc(o.text), cls: cls, title: o.full, name: o.text };
    });
  };

  Page.prototype.defaultOff = function (st, slots) {
    slots = slots || this.slots || SLOTS;
    var items = this.itemsFor(st), sel = 0;
    items.forEach(function (it, i) { if (it.selected) sel = i; });
    return Math.max(0, Math.min(items.length - slots, sel - Math.floor(slots / 2)));
  };

  function itemHTML(it, i, style) {
    var id = 'glcp-' + i;
    return '<div class="glc-arcitem glc-arcitem--' + it.kind + (it.model ? ' glc-arcitem--model' : '') + (it.selected ? ' is-selected' : '') + '" data-i="' + i + '"' + (style ? ' style="' + style + '"' : '') + '>' +
      '<input class="glc-option-input glc-sr-only" type="' + it.type + '" id="' + id + '" name="glcp-' + (it.type === 'radio' ? 'r' : i) + '" ' + it.attr + (it.selected ? ' checked' : '') + (it.disabled ? ' disabled' : '') + '>' +
      '<label for="' + id + '" class="' + esc(it.cls) + '" title="' + esc(it.title) + '">' + it.inner + '</label>' +
      (it.kind === 'swatch' ? '<span class="glc-arcitem__name">' + esc(it.name) + '</span>' : '') +
      '</div>';
  }

  // riga dell'elenco da telefono: prende foto / colore / sovrapprezzo dall'etichetta dell'app
  function rowInner(it, model) {
    var tmp = document.createElement('div');
    tmp.innerHTML = it.inner;
    var img = tmp.querySelector('img'), sw = tmp.querySelector('.glc-swatch'), pr = tmp.querySelector('.glc-value__price');
    var thumb = '';
    if (model && model.image) thumb = '<img class="glc-mrow__img" src="' + esc(model.image) + '" alt="" loading="lazy" width="56" height="56">';
    else if (img) thumb = '<img class="glc-mrow__img" src="' + esc(img.getAttribute('src')) + '" alt="" loading="lazy" width="56" height="56">';
    else if (sw) thumb = '<span class="glc-mrow__sw" style="' + esc(sw.getAttribute('style') || '') + '"></span>';
    var name = model ? model.title : (it.name || it.title), sub = pr ? txt(pr) : '';
    return { thumb: thumb, txt: '<span class="glc-mrow__txt"><span class="glc-mrow__name">' + esc(name) + '</span>' + (sub ? '<span class="glc-mrow__sub">' + esc(sub) + '</span>' : '') + '</span>' };
  }
  function rowHTML(it, i, model) {
    var id = 'glcp-' + i, tmp = document.createElement('div');
    tmp.innerHTML = it.inner;
    var img = tmp.querySelector('img'), sw = tmp.querySelector('.glc-swatch'), pr = tmp.querySelector('.glc-value__price');
    var thumb = '';
    if (model && model.image) thumb = '<img class="glc-mrow__img" src="' + esc(model.image) + '" alt="" loading="lazy" width="56" height="56">';
    else if (img) thumb = '<img class="glc-mrow__img" src="' + esc(img.getAttribute('src')) + '" alt="" loading="lazy" width="56" height="56">';
    else if (sw) thumb = '<span class="glc-mrow__sw" style="' + esc(sw.getAttribute('style') || '') + '"></span>';
    var name = model ? model.title : (it.name || it.title);
    var sub = pr ? txt(pr) : '';
    return '<div class="glc-arcitem glc-mrow-item' + (it.selected ? ' is-selected' : '') + '" data-i="' + i + '">' +
      '<input class="glc-option-input glc-sr-only" type="' + it.type + '" id="' + id + '" name="glcp-' + (it.type === 'radio' ? 'r' : i) + '" ' + it.attr + (it.selected ? ' checked' : '') + (it.disabled ? ' disabled' : '') + '>' +
      '<label for="' + id + '" class="glc-mrow' + (thumb ? '' : ' glc-mrow--text') + '" title="' + esc(it.title) + '">' + thumb +
        '<span class="glc-mrow__txt"><span class="glc-mrow__name">' + esc(name) + '</span>' + (sub ? '<span class="glc-mrow__sub">' + esc(sub) + '</span>' : '') + '</span>' +
        '<span class="glc-mrow__dot" aria-hidden="true"></span></label></div>';
  }

  Page.prototype.optsHTML = function (st, desk) {
    var self = this;
    if (st.info && st.info.kind === 'text') {
      return '<div class="glc-option glc-arcpanel"><label class="glc-option__label" for="glcp-text">' + esc(st.title) + '</label>' +
        '<input id="glcp-text" type="text" class="glc-option-text" data-glcp="text" value="' + esc(st.info.input.value) + '"></div>';
    }
    var items = this.itemsFor(st);
    if (!desk) {
      // da telefono: pulsanti corti (es. diametro, ET) restano pulsanti; tutto il resto e' un elenco
      // verticale con foto/colore, nome, prezzo e pallino di selezione
      var mk = items.length ? (items[0].model ? 'model' : items[0].kind) : 'pill';
      var short = mk === 'pill' && items.every(function (it) { return String(it.title || '').length <= 9; });
      if (short) {
        return '<div class="glc-option glc-mopt"><div class="glc-option__values glc-mpills">' +
          items.map(function (it, i) { return itemHTML(it, i, ''); }).join('') + '</div></div>';
      }
      // menu a tendina: chiuso mostra la scelta attuale (foto, nome, prezzo); aperto mostra l'elenco
      var models = this.models, open = this.mdrop === st.key;
      var chosen = items.filter(function (it) { return it.selected; });
      var face;
      if (chosen.length === 1) {
        var ci = items.indexOf(chosen[0]), r = rowInner(chosen[0], chosen[0].model ? models[ci] : null);
        face = r.thumb + r.txt;
      } else if (chosen.length > 1) {
        face = '<span class="glc-mrow__txt"><span class="glc-mrow__name">' + chosen.length + ' selezionati</span><span class="glc-mrow__sub">' + esc(chosen.map(function (c) { return c.title; }).join(', ')) + '</span></span>';
      } else {
        face = '<span class="glc-mrow__txt"><span class="glc-mrow__name">Scegli ' + esc(String(st.label || '').toLowerCase()) + '</span><span class="glc-mrow__sub">' + items.length + ' opzioni</span></span>';
      }
      var chev = '<svg class="glc-mdd__chev" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
      return '<div class="glc-option glc-mopt"><div class="glc-mdd' + (open ? ' is-open' : '') + '">' +
        '<button type="button" class="glc-mdd__btn' + (/glc-mrow__(img|sw)/.test(face) ? '' : ' glc-mdd__btn--text') + '" data-act="drop" data-key="' + esc(st.key) + '" aria-expanded="' + open + '" aria-haspopup="listbox">' + face +
          '<span class="glc-mdd__hint">' + (chosen.length ? 'Cambia' : 'Scegli') + chev + '</span></button>' +
        // pannello che sale dal basso, sotto il 3D (che resta visibile): elenco completo con foto
        (open ? '<div class="glc-sheet" role="dialog" aria-label="' + esc(st.title) + '">' +
          '<div class="glc-sheet__head"><span class="glc-sheet__title">' + esc(st.title) + '</span>' +
            '<button type="button" class="glc-sheet__close" data-act="drop" data-key="' + esc(st.key) + '">Chiudi</button></div>' +
          '<div class="glc-option__values glc-mlist2 glc-sheet__list">' +
            items.map(function (it, i) { return rowHTML(it, i, it.model ? models[i] : null); }).join('') + '</div></div>' : '') +
        '</div></div>';
    }
    // desktop: sull'arco di destra (stesso cerchio degli step), pallino sulla linea e opzione accanto.
    // Se sono tante si stringono (versione compatta) cosi' si vedono tutte; solo oltre il limite si sfoglia.
    var n = items.length, kind = items.length ? items[0].kind : 'pill';
    var comfy = { pill: 0.13, swatch: 0.13, image: 0.2 }[kind] || 0.13;
    var tight = { pill: 0.088, swatch: 0.088, image: 0.15 }[kind] || 0.088;
    var maxSpan = 2 * ARC - 0.12;
    var gap = n > 1 ? Math.min(comfy, maxSpan / (n - 1)) : comfy;
    var paged = gap < tight;
    if (paged) gap = tight;
    var slots = paged ? Math.floor(maxSpan / gap) - 1 : n;
    var off = 0, show = n;
    if (paged) {
      off = this.off[st.key] != null ? this.off[st.key] : this.defaultOff(st, slots);
      off = Math.max(0, Math.min(n - slots, off));
      this.off[st.key] = off;
      show = slots;
    }
    this.slots = slots;
    this.dense = gap < 0.115;
    var span = gap * (show - 1);
    var html = '';
    for (var k = 0; k < show; k++) {
      var i = off + k, it = items[i];
      var t = show === 1 ? 0 : -span / 2 + k * gap;
      var x = CX + R * Math.cos(t), y = CY + R * Math.sin(t);
      // verso le estremita' la curva piega sotto l'angolo del riquadro: lo sposto a destra quanto serve
      var half = { image: 36, swatch: 22, pill: this.dense ? 18 : 25 }[it.kind] || 25;
      var dx = 18 + half * Math.abs(Math.tan(t));
      html += '<span class="glc-arcdot' + (it.selected ? ' is-selected' : '') + '" style="left:' + Math.round(x) + 'px;top:' + Math.round(y) + 'px"></span>' +
        itemHTML(it, i, 'left:' + Math.round(x + dx) + 'px;top:' + Math.round(y) + 'px');
    }
    if (paged) {
      var ya = CY + R * Math.sin(-span / 2 - gap), yb = CY + R * Math.sin(span / 2 + gap);
      var xa = CX + R * Math.cos(-span / 2 - gap), xb = CX + R * Math.cos(span / 2 + gap);
      html += '<button type="button" class="glc-more" data-act="rot" data-dir="-' + slots + '" style="left:' + Math.round(xa + 20) + 'px;top:' + Math.round(ya) + 'px"' + (off === 0 ? ' hidden' : '') + '>&uarr; ' + off + ' precedenti</button>' +
        '<button type="button" class="glc-more" data-act="rot" data-dir="' + slots + '" style="left:' + Math.round(xb + 20) + 'px;top:' + Math.round(yb) + 'px"' + (off + show >= n ? ' hidden' : '') + '>&darr; Altre ' + (n - off - show) + ' opzioni</button>';
    }
    return html;
  };

  /* ---------- render ---------- */
  Page.prototype.render = function () {
    var steps = this.steps(), cur = this.currentStep(steps), st = steps[cur];
    var desk = DESKTOP.matches;
    this.el.classList.toggle('is-desktop', desk);
    // a ogni fase il cerchio si gira sull'inquadratura che la mostra meglio
    // (beadlock e attacco: frontale; il resto: 3/4)
    if (st && st.key !== this._viewStep) {
      var first = this._viewStep == null;
      this._viewStep = st.key;
      var vi = viewFor(st), self0 = this;
      if (!(first && vi === 0)) setTimeout(function () { self0.goView(vi); }, 60);
    }
    if (desk && !this._arcs) {
      this._arcs = true;
      var ax = Math.round(R * Math.cos(ARC)), ay = Math.round(R * Math.sin(ARC));
      var ps = this.el.querySelectorAll('.glc-arcs path');
      if (ps[0]) ps[0].setAttribute('d', 'M' + (CX - ax) + ' ' + (CY - ay) + ' A' + R + ' ' + R + ' 0 0 0 ' + (CX - ax) + ' ' + (CY + ay));
      if (ps[1]) ps[1].setAttribute('d', 'M' + (CX + ax) + ' ' + (CY - ay) + ' A' + R + ' ' + R + ' 0 0 1 ' + (CX + ax) + ' ' + (CY + ay));
    }
    // anteprime delle viste: si rifanno quando cambia la configurazione
    if (this.root) {
      var sig = this.model.handle + '|' + steps.map(function (s) { return s.value; }).join('|');
      if (this._sig !== sig) { if (this._sig != null) { this.queueSnap(60); this._snapAgain = Date.now() + 700; } this._sig = sig; }
    }

    // testata: occhiello + titolo con la classe h2 del tema
    this.$('[data-glc-head]').innerHTML =
      '<h1 class="h2 glc-title">' + esc(this.t.eyebrow || this.model.title) + '</h1>' +
      '<p class="glc-sub">' +
        (this.root ? '<span class="glc-sub__step">Passo ' + (cur + 1) + ' di ' + steps.length + '</span><span class="glc-sub__title">' + esc(st.title) + '</span>'
                   : '<span class="glc-sub__title">' + esc(this.model.title) + '</span>') + '</p>';

    // step
    var stepsEl = this.$('[data-glc-steps]');
    if (desk) {
      var n = steps.length, span = Math.min(2 * ARC - 0.12, 0.18 * (n - 1));
      stepsEl.className = 'glc-steps';
      stepsEl.innerHTML = steps.map(function (s, i) {
        var t = n === 1 ? 0 : -span / 2 + i * (span / (n - 1));
        var px = CX - R * Math.cos(t), py = CY + R * Math.sin(t), active = i === cur, size = active ? 44 : 34;
        return '<button type="button" class="glc-step' + (active ? ' is-active' : '') + (s.done ? ' is-done' : '') + '" data-act="step" data-key="' + esc(s.key) + '" aria-current="' + (active ? 'step' : 'false') + '" style="left:' + Math.round(px - 250) + 'px;top:' + Math.round(py - 24) + 'px">' +
            '<span class="glc-step__txt"><span class="glc-step__name">' + esc(s.label) + (s.required && !s.done ? '<i aria-hidden="true">*</i>' : '') + '</span>' +
            '<span class="glc-step__value">' + esc(s.value) + '</span></span>' +
            '<span class="glc-step__node" style="width:' + size + 'px;height:' + size + 'px;margin-right:' + (-size / 2) + 'px">' + (i + 1) + '</span>' +
          '</button>';
      }).join('');
    } else {
      stepsEl.className = 'glc-steps';
      stepsEl.innerHTML = '';
    }
    var mnav = this.$('[data-glc-mnav]');
    if (mnav) mnav.innerHTML = (!desk && this.root) ? this.mnavHTML(steps, cur) : '';

    // opzioni dello step attivo
    var panel = this.$('[data-glc-opts]');
    var focused = document.activeElement && panel.contains(document.activeElement) && document.activeElement.type === 'text';
    if (!focused) {
      var row = panel.querySelector('[data-glc-hscroll]');
      var keep = row && this._rowKey === st.key ? row.scrollLeft : null;
      panel.innerHTML = this.optsHTML(st, desk);
      panel.classList.toggle('is-dense', !!(desk && this.dense));
      row = panel.querySelector('[data-glc-hscroll]');
      if (row) {
        if (keep != null) row.scrollLeft = keep;
        else {
          var selEl = row.querySelector('.glc-arcitem.is-selected');
          if (selEl) row.scrollLeft = Math.max(0, selEl.offsetLeft - row.clientWidth / 2 + selEl.clientWidth / 2);
        }
      }
      this._rowKey = st.key;
    }

    // prezzo + pulsanti del tema
    var buy = this.$('[data-glc-buy]');
    if (!this.root) { buy.innerHTML = ''; }
    else {
      var v = this.variant(), sup = this.supplement(), ext = this.extrasTotal();
      var btn = this.submitButton();
      var last = cur >= steps.length - 1;
      var notes = [this.t.priceNote || ''];
      if (sup) notes.push((this.t.supplementLabel || 'Personalizzazioni') + ' +' + this.money(sup));
      if (ext) notes.push('Extra +' + this.money(ext));
      buy.innerHTML =
        '<div class="glc-buy__price">' +
          '<price-list class="price-list price-list--lg"><sale-price class="text-lg"><span class="sr-only">Prezzo</span>' + (v ? this.money(v.price + sup + ext) : '—') + '</sale-price></price-list>' +
          '<p class="glc-buy__note">' + esc(notes.filter(Boolean).join(' · ')) + '</p>' +
        '</div>' +
        '<div class="glc-buy__actions">' +
          (!last
            ? '<button type="button" class="button button--xl button--secondary" data-act="next">Avanti</button>'
            : '<button type="button" class="button button--xl button--secondary" data-act="add"' + (!btn || btn.disabled || this.busy ? ' disabled' : '') + '>' +
                (this.busy ? 'Aggiungo…' : esc(btn ? txt(btn) : 'Aggiungi al carrello')) + '</button>') +
        '</div>';
    }

    this.syncSheet();
    var m = this.$('[data-glc-msg]');
    m.textContent = this.msg; m.className = 'glc-msg' + (this.msgType ? ' is-' + this.msgType : '');
    this.fit();
  };

  // da telefono: ‹ step › con barra a segmenti; toccando il nome si apre l'elenco di tutti gli step
  var ICON_L = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg>';
  var ICON_R = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';
  Page.prototype.mnavHTML = function (steps, cur) {
    var st = steps[cur], n = steps.length, open = !!this.mlist;
    var val = st.value && st.value !== '—' ? st.value : (st.required ? 'da scegliere' : '');
    return '<div class="glc-mnav__row">' +
        '<button type="button" class="glc-mnav__arrow" data-act="prev" aria-label="Passo precedente"' + (cur === 0 ? ' disabled' : '') + '>' + ICON_L + '</button>' +
        '<button type="button" class="glc-mnav__cur" data-act="list" aria-expanded="' + open + '">' +
          '<b>' + esc(st.label) + (st.required && !st.done ? '<i aria-hidden="true">*</i>' : '') + '</b>' +
          '<span>Passo ' + (cur + 1) + ' di ' + n + (val ? ' · ' + esc(val) : '') + '</span>' +
          '<em aria-hidden="true">' + (open ? 'Chiudi' : 'Riepilogo') + '</em>' +
        '</button>' +
        '<button type="button" class="glc-mnav__arrow" data-act="next" aria-label="Passo successivo"' + (cur >= n - 1 ? ' disabled' : '') + '>' + ICON_R + '</button>' +
      '</div>' +
      '<div class="glc-mnav__bar" role="list">' + steps.map(function (s, i) {
        return '<button type="button" role="listitem" class="glc-mnav__seg' + (i === cur ? ' is-active' : '') + (s.done ? ' is-done' : '') + '" data-act="step" data-key="' + esc(s.key) + '" aria-label="' + (i + 1) + '. ' + esc(s.label) + '"></button>';
      }).join('') + '</div>' +
      (open ? '<div class="glc-mlist">' + steps.map(function (s, i) {
        return '<button type="button" class="glc-mlist__item' + (i === cur ? ' is-active' : '') + (s.done ? ' is-done' : '') + '" data-act="step" data-key="' + esc(s.key) + '">' +
          '<span class="glc-mlist__num">' + (i + 1) + '</span>' +
          '<span class="glc-mlist__label">' + esc(s.label) + (s.required && !s.done ? '<i aria-hidden="true">*</i>' : '') + '</span>' +
          '<span class="glc-mlist__value">' + esc(s.value) + '</span></button>';
      }).join('') + '</div>' : '');
  };
  // pannello delle opzioni: parte subito sotto il 3D, blocca lo scorrimento della pagina finche' e' aperto
  Page.prototype.syncSheet = function () {
    var sh = this.el.querySelector('.glc-sheet'), root = document.documentElement;
    this.el.classList.toggle('is-sheet', !!sh && !DESKTOP.matches);
    if (!sh || DESKTOP.matches) { root.classList.remove('glc-lock'); this._sheetKey = null; return; }
    var viewer = this.$('[data-glc-viewer]');
    // il 3D si sta rimpicciolendo (transizione): calcolo subito dove finira' il suo bordo inferiore
    var slot = this.$('[data-glc-3d-slot]');
    var finalH = Math.max(190, Math.min(window.innerHeight * 0.26, window.innerWidth * 0.62));
    var shrink = slot ? Math.max(0, slot.getBoundingClientRect().height - finalH) : 0;
    var top = viewer ? Math.round(viewer.getBoundingClientRect().bottom - shrink) : 0;
    sh.style.top = Math.max(0, Math.min(top, window.innerHeight - 260)) + 'px';
    root.classList.add('glc-lock');
    if (this._sheetKey !== this.mdrop) {
      this._sheetKey = this.mdrop;
      var sel = sh.querySelector('.glc-option-input:checked');
      if (sel) { var row = sel.closest('.glc-mrow-item'), list = sh.querySelector('.glc-sheet__list'); list.scrollTop = Math.max(0, row.offsetTop - list.clientHeight / 2 + row.clientHeight / 2); }
    }
  };

  // da telefono: dopo il cambio step porto le opzioni subito sotto il 3D
  Page.prototype.alignMobile = function () {
    if (DESKTOP.matches) return;
    var panel = this.$('[data-glc-opts]'), viewer = this.$('[data-glc-viewer]');
    if (!panel || !viewer) return;
    var vb = viewer.getBoundingClientRect().bottom, pt = panel.getBoundingClientRect().top;
    if (pt < vb - 2 || pt > window.innerHeight * 0.75) window.scrollBy({ top: pt - vb - 6, behavior: 'smooth' });
  };

  Page.prototype.fit = function () {
    var stage = this.$('[data-glc-stage]'), canvas = this.$('[data-glc-canvas]');
    if (!DESKTOP.matches) { canvas.style.transform = ''; stage.style.height = ''; return; }
    var w = stage.clientWidth, k = Math.min(1, w / W);
    canvas.style.transform = 'translateX(' + Math.max(0, (w - W) / 2) + 'px) scale(' + k + ')';
    stage.style.height = Math.round(H * k) + 'px';
  };

  function boot() {
    document.querySelectorAll('[data-glc]').forEach(function (el) { if (!el._glc) el._glc = new Page(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
